module.exports = __webpack_public_path__ + "static/media/life-support.c0c7c040.svg";